import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { APIGetCompany } from './company.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyConnectorService {
  http = inject(HttpClient);

  getCompanies(): Promise<APIGetCompany[]> {
    return lastValueFrom<APIGetCompany[]>(
      this.http.get<APIGetCompany[]>(environment.baseUrl + `/companies`),
    );
  }

  updateCompany(company: APIGetCompany): Promise<APIGetCompany> {
    return lastValueFrom<APIGetCompany>(
      this.http.put<APIGetCompany>(environment.baseUrl + `/companies/${company.id}`, company),
    );
  }

  async uploadLogo(file: File, companyName: string): Promise<string> {
    const form = new FormData();
    form.append('file', file);
    form.append('companyName', companyName);
    const response = await lastValueFrom(
      this.http.post<{ url: string }>(environment.baseUrl + `/companies/upload-logo`, form),
    );
    return response.url;
  }
}
